import { useModelQuery } from "@/apollo/types";
import { ModelIcon } from "@/pages/ModelTool/components/ModelIcon/ModelIcon";
import { useFullModelPathRenderer } from "@/pages/ModelTool/hooks/useFullPathNames";

export function ModelBreadcrumb(props: { modelId: string }) {
  const { data } = useModelQuery({
    variables: {
      modelId: props.modelId,
    },
  });
  const modelPath = useFullModelPathRenderer({
    modelFolderId: data?.model?.folder?.id ?? null,
    modelName: data?.model?.name ?? null,
  });
  if (data?.model == null) return null;
  return (
    <div className="flex items-center gap-2">
      <ModelIcon model={data.model} className="size-5" />
      <span className="truncate">{modelPath}</span>
    </div>
  );
}
